angular.module('zc.zenclerkS')
  .factory('ZcsTiming', ZcsTiming);

ZcsTiming.$inject = ['$translate', 'ZcsOemService'];
function ZcsTiming($translate, ZcsOemService) {
  const service = {};

  // timing plans
  service.timingPlans = [
    {
      name: 'ai',
      label: $translate.instant('services.timing.deliveryAi'),
      class: 'recommended',
      description: $translate.instant('services.timing.deliveryAiDescription', { service: ZcsOemService.getName() }),
      button_text: $translate.instant('services.timing.selectToProceed'),
      icon: '/assets/img/illustration-delivery-ai.svg',
    },
    {
      name: 'all',
      label: $translate.instant('services.timing.deliverySegment'),
      class: '',
      description: $translate.instant('services.timing.deliverySegmentDescription'),
      button_text: $translate.instant('services.timing.selectToProceed'),
      icon: '/assets/img/illustration-delivery-all.svg',
    },
  ];

  return service;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/timing.service.js